export default{
    id:"id",
    relatedProfession:"related_profession",
    description:"description",
    suggesterName:"suggester_name",
    suggesterNumber:"suggester_number",
    suggesterStudyField:"suggester_study_field",
    createdAt:"created_at"
}